/* ============================================================
 * lbf-shipping-popup.js  (v1.4 - transition polish and copy reverts)
 * Shared two-step shipping explanation for collection and cart.
 * Rates and thresholds come only from window.LBF_SHIPPING.
 * ============================================================ */
(function () {
  'use strict';
  var lbnT = window.lbnT || function (k, f, v) { return v ? String(f).replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, x) { return Object.prototype.hasOwnProperty.call(v, x) ? String(v[x]) : m; }) : f; };
  if (window.LBF_SHIPPING_POPUP || !window.LBF_SHIPPING) return;

  var CORE = window.LBF_SHIPPING;
  var rootEl = null;
  var sheetEl = null;
  var cart = null;
  var step = 1;
  var trigger = 'button';
  var reason = 'manual';
  var opener = null;
  var openedAt = 0;
  var changedArea = false;
  var touchX = null;
  var touchY = null;
  var direction = 'forward';
  var animatePanel = false;
  var escapeConsumed = false;
  var previousOverflow = '';
  var heightTimer = null;
  function clearHeightMotion() {
    window.clearTimeout(heightTimer);
    heightTimer = null;
    if (!sheetEl) return;
    sheetEl.style.height = '';
    sheetEl.style.overflow = '';
    sheetEl.style.transition = '';
  }
  function reducedMotion() { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; }

  function surface() { return /^\/cart(?:\/|$)/.test(window.location.pathname) ? 'cart' : 'collection'; }
  function frozenCart() { return !!(cart && cart.items && cart.items.some(function (item) { return item.frozenTag; })); }
  function mixedCart() { return !!CORE.classify(cart || { items: [] }).mixed; }
  function getState() { return CORE.activeRegion(frozenCart()); }
  function push(event, data) {
    try {
      window.dataLayer = window.dataLayer || [];
      var payload = data || {};
      payload.event = event;
      window.dataLayer.push(payload);
    } catch (e) {}
  }
  function announceState(value) {
    try {
      document.dispatchEvent(new CustomEvent('lbf:shipping-state-change', {
        detail: { state: value, source: 'shipping-popup' }
      }));
    } catch (e) {}
  }
  function esc(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function countPhrase(n, singular, plural) {
    return '<strong>' + n + ' ' + (n === 1 ? singular : plural) + '</strong>';
  }
  function fmtWhole(cents) { return 'RM' + Math.round(Number(cents || 0) / 100); }
  function current() { return CORE.compute(cart || { items: [], totalPrice: 0 }, CORE.activeRegion(frozenCart()), { ignoreMoq: true }); }

  function injectCSS() {
    if (document.getElementById('lbf-ship-popup-css')) return;
    var css = document.createElement('style');
    css.id = 'lbf-ship-popup-css';
    css.textContent =
      '.lbfsp{position:fixed;inset:0;z-index:2147483000;display:none;align-items:flex-end;justify-content:center;font-family:inherit}.lbfsp,.lbfsp *{box-sizing:border-box}' +
      '.lbfsp.is-open{display:flex}.lbfsp__scrim{display:block!important;position:absolute;inset:0;background:rgba(15,13,12,.74);-webkit-backdrop-filter:blur(2px);backdrop-filter:blur(2px);opacity:0;transition:opacity .2s}.lbfsp.is-open .lbfsp__scrim{opacity:1}' +
      '.lbfsp__sheet{position:relative;width:100%;max-height:85vh;overflow:auto;background:#fff;color:#1f1a18;border-radius:18px 18px 0 0;padding:22px 18px calc(18px + env(safe-area-inset-bottom,0px));box-shadow:0 -12px 40px rgba(0,0,0,.22);outline:none;transform:translateY(105%);transition:transform .24s cubic-bezier(.4,0,.2,1),height .22s ease}' +
      '.lbfsp.is-open .lbfsp__sheet{transform:translateY(0)}.lbfsp__grab{display:block!important;position:relative;width:84px;height:24px;margin:-10px auto 4px;cursor:grab;touch-action:pan-y}.lbfsp__grab:before{content:"";position:absolute;top:10px;left:20px;width:44px;height:4px;border-radius:99px;background:#d8d2cd}' +
      '.lbfsp__panel{padding-top:8px}.lbfsp__panel.is-forward{animation:lbfsp-left .22s ease}.lbfsp__panel.is-back{animation:lbfsp-right .22s ease}@keyframes lbfsp-left{from{opacity:.25;transform:translateX(22px)}to{opacity:1;transform:none}}@keyframes lbfsp-right{from{opacity:.25;transform:translateX(-22px)}to{opacity:1;transform:none}}' +
      '.lbfsp h2{margin:0;font-size:23px;font-weight:700;line-height:1.25;letter-spacing:-.01em}.lbfsp__lede{margin:11px 0 18px;color:#5d554f;font-size:14px;line-height:1.55;letter-spacing:.005em}' +
      '.lbfsp__areas{border:1px solid #e8e2dd;border-radius:12px;overflow:hidden}.lbfsp__area{display:flex;width:100%;align-items:center;justify-content:space-between;gap:12px;padding:15px 14px;border:0;border-bottom:1px solid #eee9e5;background:#fff;color:#2b2521;font:inherit;font-size:15px;font-weight:750;text-align:left;cursor:pointer}.lbfsp__area:last-child{border-bottom:0}.lbfsp__area[disabled]{background:#f6f4f2;color:#aaa;cursor:not-allowed}.lbfsp__area-copy{display:block;min-width:0}.lbfsp__area-sub{display:block;margin-top:3px;color:#7b716a;font-size:11px;font-weight:500;line-height:1.3}.lbfsp__na{font-size:11px;font-weight:600}.lbfsp__tick{color:#2D8A2D;font-size:18px}' +
      '.lbfsp__hero{background:#FDF4EA;border:1px solid #F2E1CB;border-radius:14px;padding:16px 17px;margin:0 0 16px}.lbfsp__hero.is-free{background:#EDF7EE;border-color:#C6E3CB}.lbfsp__hero.is-flat{background:#F6F3EF;border-color:#E5DFD7}.lbfsp__caption{margin:0 0 14px;font-size:11.5px;font-weight:700;color:#6E6259;text-transform:uppercase;letter-spacing:.45px;line-height:1.4}.lbfsp__fee-row{display:flex;justify-content:space-between;align-items:baseline;gap:12px;margin:0 0 15px;min-width:0}.lbfsp__fee-label{flex:0 0 auto;margin:0;font-size:13px;font-weight:700;color:#7a7169;line-height:1.35;white-space:nowrap}.lbfsp__figure{min-width:0;margin:0;font-size:24px;font-weight:700;color:#151311;line-height:1.1;letter-spacing:-.25px;text-align:right;white-space:nowrap}.lbfsp__figure.is-free{color:#1E7A33}.lbfsp__figure del{font-size:15px;font-weight:600;color:#A79C90;margin-right:7px;letter-spacing:0}.lbfsp__split-more{color:#1A5490;margin-left:2px}.lbfsp__cartrow{display:flex;justify-content:space-between;align-items:baseline;gap:12px;font-size:14px;font-weight:700;color:#2b2521;line-height:1.4}.lbfsp__cartrow-value{white-space:nowrap}.lbfsp__cartrow-value em{font-style:normal;font-weight:700;color:#8a8279}.lbfsp__track{height:8px;border-radius:999px;background:#E7E2DA;margin:12px 0 0;overflow:hidden}.lbfsp__track i{display:block;height:100%;border-radius:999px;background:#F5C518}.lbfsp__hero.is-free .lbfsp__track i{background:#3AA34C}.lbfsp__goal{margin:16px 0 0;font-size:14.5px;color:#2b2521;line-height:1.5}.lbfsp__goal strong{font-weight:700}.lbfsp__goal .is-free-copy{color:#1E7A33;font-weight:700}.lbfsp__goal.is-done{color:#1E7A33;font-weight:700}.lbfsp__goal.is-flat{font-size:14px}.lbfsp__foot{margin:13px 0 0;font-size:12.5px;font-weight:400;color:#514943;line-height:1.55}.lbfsp__choice{margin:14px 0 0;padding-top:13px;border-top:1px solid #EAD8C4;font-size:12.5px;font-weight:400;color:#514943;line-height:1.55}.lbfsp__hero.is-mixed .lbfsp__foot{margin-top:14px;padding-top:13px;border-top:1px solid #EAD8C4}.lbfsp__hero.is-mixed.is-free .lbfsp__foot{border-top-color:#C6E3CB}.lbfsp__hero.is-mixed .lbfsp__choice{margin-top:9px;padding-top:0;border-top:none}.lbfsp__boxes{margin:14px 0 0;padding-top:13px;border-top:1px solid #EAD8C4}.lbfsp__boxes-h{margin:0 0 10px;font-size:14px;font-weight:800;color:#2b2521}.lbfsp__box{background:#fff;border:1px solid #EFE4D6;border-radius:10px;padding:10px 12px;margin:0 0 8px}.lbfsp__box-t{margin:0 0 5px;font-size:11.5px;font-weight:800;letter-spacing:.35px;text-transform:uppercase;color:#6E6259;white-space:nowrap}.lbfsp__boxitems{margin:0;padding:0 0 0 16px;font-size:13px;color:#2b2521;line-height:1.5}.lbfsp__boxitems li{margin:0 0 2px}.lbfsp__boxitems em{font-style:normal;color:#8a8279}.lbfsp__box-sub{margin:6px 0 0;font-size:12px;color:#8a8279}.lbfsp__box-head{display:flex;justify-content:space-between;align-items:baseline;gap:10px}.lbfsp__box-prog{margin:4px 0 0;font-size:12px;color:#8a8279}.lbfsp__lede.is-second{margin-top:-8px}.lbfsp__box-fee del{font-size:12px;font-weight:600;color:#A79C90;margin-right:5px;letter-spacing:0}.lbfsp__boxes-h2{margin:14px 0 6px;font-size:13px;font-weight:800;color:#2b2521}.lbfsp__more{display:block;margin:2px 0 0;padding:4px 0;border:0;background:none;font:inherit;font-size:12.5px;color:#1A5490;cursor:pointer;text-align:left}.lbfsp__boxitems .lbfsp__extra[hidden]{display:none}.lbfsp__box-fee{margin:0 0 5px;font-size:15px;font-weight:800;color:#2b2521;white-space:nowrap}.lbfsp__box-win{color:#1E7A33;font-weight:700}.lbfsp__boxes-note{margin:10px 0 0;font-size:12.5px;font-weight:400;color:#514943;line-height:1.55}.lbfsp__boxes-why{margin:8px 0 0;font-size:12.5px;font-weight:400;color:#514943;line-height:1.55}.lbfsp__hero.is-free .lbfsp__choice{border-top-color:#C6E3CB}.lbfsp__cartrow-value del{font-weight:600;color:#A79C90;margin-right:5px}' +
      '.lbfsp__buttons{display:flex;gap:11px;margin-top:19px}.lbfsp__btn{flex:1;border:1.5px solid #1f1a18;border-radius:11px;background:#ffe100;color:#1f1a18;padding:15px 10px;font:inherit;font-size:13px;font-weight:800;cursor:pointer;text-transform:uppercase}.lbfsp__btn.is-ghost{background:#fff}' +
      '.lbfsp__rates{margin:15px 0 0}.lbfsp__all-rates{border:1px solid #e4ddd6;border-radius:10px;background:#fff;overflow:hidden}.lbfsp__all-rates summary{padding:13px 14px;font-size:12px;font-weight:700;color:#1a5490;cursor:pointer;list-style:none}.lbfsp__all-rates summary::-webkit-details-marker{display:none}.lbfsp__all-rates[open] summary{border-bottom:1px solid #e4ddd6}.lbfsp__all-rates-body{padding:13px}.lbfsp__rates-title{margin:0 0 9px;font-size:13px;font-weight:800;color:#2b2521}.lbfsp__rate-gap{display:block!important;height:18px;font-size:0;line-height:0}.lbfsp__ratecard{border:1px solid #e4ddd6;border-radius:12px;overflow:hidden;background:#fff}.lbfsp__ratehead{display:flex;justify-content:space-between;gap:10px;padding:11px 12px;background:#f5f1ed;border-bottom:1px solid #e4ddd6}.lbfsp__ratehead b{font-size:12px;letter-spacing:.25px}.lbfsp__ratehead span{font-size:10.5px;color:#6e6259;text-align:right}.lbfsp__raterow{display:grid;grid-template-columns:minmax(0,1.15fr) minmax(82px,.8fr) auto;align-items:center;gap:8px;min-height:43px;padding:8px 12px;border-bottom:1px solid #eee8e2;font-size:12px;line-height:1.25}.lbfsp__raterow:last-child{border-bottom:0}.lbfsp__raterow.is-current{background:#fff8cf;border-left:4px solid #f5c518;padding-left:8px}.lbfsp__ratefee{font-weight:800;text-align:right;white-space:nowrap}.lbfsp__ratefee.is-free{color:#1e7a33}.lbfsp__ratemark{display:block;margin-top:3px;color:#7a5b00;font-size:9.5px;font-weight:800;text-transform:uppercase}' +
      '@media(max-height:700px){.lbfsp__sheet{padding:16px 18px calc(10px + env(safe-area-inset-bottom,0px))}.lbfsp__grab{margin-bottom:-2px}.lbfsp h2{font-size:21px;line-height:1.25}.lbfsp__lede{margin:9px 0 15px;font-size:13.5px;line-height:1.55}.lbfsp__hero{margin-bottom:11px}.lbfsp__buttons{margin-top:11px}.lbfsp__btn{padding:12px 8px}}' +
      '@media(max-width:380px){.lbfsp__sheet{padding-left:13px;padding-right:13px}.lbfsp__raterow{grid-template-columns:minmax(0,1fr) minmax(74px,.72fr) auto;padding-left:9px;padding-right:9px;font-size:11.5px}.lbfsp__raterow.is-current{padding-left:5px}.lbfsp__ratehead{padding-left:9px;padding-right:9px}}' +
      '@media(min-width:750px){.lbfsp{align-items:center;padding:28px}.lbfsp__sheet{max-width:470px;border-radius:18px;padding:22px 24px 24px}.lbfsp h2{font-size:26px}}';
    css.textContent += '@media(prefers-reduced-motion:reduce){.lbfsp__sheet,.lbfsp__scrim{transition:none}.lbfsp__panel{animation:none!important}}';
    document.head.appendChild(css);
  }

  function ensure() {
    if (rootEl) return;
    injectCSS();
    rootEl = document.createElement('div');
    rootEl.className = 'lbfsp';
    rootEl.setAttribute('aria-hidden', 'true');
    rootEl.innerHTML = '<div class="lbfsp__scrim" data-lbfsp-close></div><section class="lbfsp__sheet" role="dialog" aria-modal="true" aria-labelledby="lbfsp-title" tabindex="-1"><div class="lbfsp__grab"></div><div class="lbfsp__content"></div></section>';
    document.body.appendChild(rootEl);
    sheetEl = rootEl.querySelector('.lbfsp__sheet');
    var grabEl = rootEl.querySelector('.lbfsp__grab');
    rootEl.addEventListener('click', onClick);
    grabEl.addEventListener('touchstart', function (e) {
      var touch = e.touches && e.touches[0];
      var atTop = sheetEl.scrollTop <= 1;
      touchX = atTop && touch ? touch.clientX : null;
      touchY = atTop && touch ? touch.clientY : null;
    }, { passive: true });
    grabEl.addEventListener('touchend', function (e) {
      var touch = e.changedTouches && e.changedTouches[0];
      var dx = touchX == null || !touch ? 0 : touch.clientX - touchX;
      var dy = touchY == null || !touch ? 0 : touch.clientY - touchY;
      touchX = null;
      touchY = null;
      if (sheetEl.scrollTop <= 1 && dy > 80 && Math.abs(dy) > Math.abs(dx)) close('swipe');
    }, { passive: true });
    grabEl.addEventListener('touchcancel', function () { touchX = null; touchY = null; }, { passive: true });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (rootEl.classList.contains('is-open')) {
        escapeConsumed = true;
        e.preventDefault();
        e.stopImmediatePropagation();
        close('escape');
      } else if (escapeConsumed && e.repeat) {
        e.preventDefault();
        e.stopImmediatePropagation();
      } else {
        escapeConsumed = false;
      }
    }, true);
    // Focus returns to the cart on keydown. Consume that same key's keyup,
    // otherwise the underlying drawer also closes from a single Escape.
    document.addEventListener('keyup', function (e) {
      if (e.key !== 'Escape' || !escapeConsumed) return;
      escapeConsumed = false;
      e.preventDefault();
      e.stopImmediatePropagation();
    }, true);
    window.addEventListener('blur', function () { escapeConsumed = false; });
  }

  function renderStep1() {
    var frozen = frozenCart();
    var selected = frozen ? CORE.getFrozenRegion() : CORE.getRegularRegion();
    var promptedFrozen = frozen && reason === 'frozen-added';
    var rows = frozen ? [
      ['kl-sel', lbnT('ship.kl_selangor', 'KL / Selangor')], ['wm', lbnT('ship.pop_area_outside_kl', 'Outside KL / Selangor'), false, lbnT('ship.pop_area_outside_kl_sub', 'Penang, Johor and other West Malaysia states')],
      /* Cart journey 2026-09-26: shown so nobody wonders where East Malaysia went, but never pickable. */
      ['east-msia', lbnT('ship.sabah_sarawak', 'Sabah / Sarawak'), true, lbnT('ship.pop_area_east_na', 'Not available for frozen dishes')]
    ] : [['west-msia', lbnT('ship.west_malaysia', 'West Malaysia')], ['east-msia', lbnT('ship.sabah_sarawak', 'Sabah / Sarawak')]];
    var animClass = animatePanel ? (direction === 'back' ? 'is-back' : 'is-forward') : '';
    var html = '<div class="lbfsp__panel ' + animClass + '">' +
      '<h2 id="lbfsp-title">' + lbnT('ship.pop_select_area', 'Select your delivery area.') + '</h2>' +
      '<p class="lbfsp__lede">' + (mixedCart()
        ? lbnT('ship.pop_lede_mixed', 'Your cart mixes frozen and ready-to-eat dishes, so your whole order will be delivered by refrigerated truck. The delivery fee depends on your area.')
        : frozen
        ? lbnT('ship.pop_lede_frozen', 'Your cart includes frozen food, so your whole order will be delivered by refrigerated truck. The delivery fee depends on your area.')
        : lbnT('ship.pop_lede_rte', 'Your cart has ready-to-eat items which can be shipped by regular courier. Delivery cost depends on how far your order has to travel.')) + '</p><div class="lbfsp__areas">';
    rows.forEach(function (row) {
      html += '<button type="button" class="lbfsp__area" data-lbfsp-area="' + row[0] + '"' + (row[2] ? ' disabled aria-disabled="true"' : '') + '><span class="lbfsp__area-copy"><span>' + row[1] + '</span>' + (row[3] ? '<span class="lbfsp__area-sub">' + row[3] + '</span>' : '') + '</span>' +
        (selected === row[0] ? '<span class="lbfsp__tick">✓</span>' : '') + '</button>';
    });
    html += '</div></div>';
    return html;
  }

  function sentence(s, frozen) {
    if (s.kind === 'blocked') {
      var blocked = lbnT('ship.blocked_there', "We can't ship the frozen dishes in your cart there.");
      if (s.readyQty) blocked += ' ' + lbnT('ship.pop_blocked_rte_ok', 'Your ready-to-eat items can still be delivered by regular courier.');
      return blocked;
    }
    /* Carl 2026-09-18: "need their own foam boxes" states the fact but not the
       reason. The reason is a courier restriction - cold-chain boxes have to hold
       a fixed form and size - so say that, then the consequence. */
    if (s.splitWarn) return lbnT('ship.pop_why_split', 'Seasonal dishes use a different approved foam-box size from our regular products. Combining them would create a non-standard parcel the carrier cannot accept.');
    if (s.mixed) return lbnT('ship.pop_why_mixed', 'Your frozen and ready-to-eat dishes will travel together in one refrigerated delivery.');
    if (frozen) return lbnT('ship.pop_why_frozen', "Your cart includes frozen dishes, so we'll ship your entire order, including ready-to-eat items, by refrigerated truck.");
    return s.state === 'east-msia'
      ? lbnT('ship.pop_why_rte_east', "All items in your cart are ready-to-eat, so we'll ship them to Sabah or Sarawak by regular courier, such as Pos Laju.")
      : lbnT('ship.pop_why_rte_west', "All items in your cart are ready-to-eat, so we'll ship them by regular courier, such as Pos Laju.");
  }

  function singleTargetCard(s, frozen) {
    /* A split cart has no single lane to describe, so the hero states the TOTAL
       and hands every other detail to the two-box panel underneath. Showing a
       one-lane fee here while the panel totals something else was contradictory. */
    if (s.split && s.split.quotable && s.kind !== 'blocked') {
      return { caption: '', feeLabel: lbnT('ship.pop_total_fee', 'Total delivery fee'),
        fee: s.split.total === 0 ? lbnT('ship.free_caps', 'FREE') : CORE.fmt(s.split.total), free: s.split.total === 0, showCart: false, splitTotal: true, goal: '', foot: '' };
    }
    if (s.kind === 'blocked') {
      return {
        caption: lbnT('ship.pop_cap_cold_east', 'Cold-chain · Sabah / Sarawak'), fee: lbnT('ship.not_available', 'Not available'), blocked: true,
        goal: lbnT('ship.pop_goal_west_only', 'Refrigerated trucks only run within West Malaysia.'),
        foot: lbnT('ship.pop_foot_rte_east', 'Ready-to-eat packs still reach Sabah and Sarawak by regular courier, from {{ amount }}.', { amount: CORE.fmt(CORE.EAST_FROM) })
      };
    }
    if (!frozen && s.state === 'east-msia') {
      return {
        caption: lbnT('ship.pop_cap_regular_east', 'Regular delivery to Sabah / Sarawak'), fee: lbnT('ship.from_amount', 'From {{ amount }}', { amount: CORE.fmt(CORE.EAST_FROM) }), flat: true, showCart: true,
        goal: lbnT('ship.pop_goal_by_weight', 'Charged by weight, not by cart value.'),
        foot: lbnT('ship.pop_foot_east_rates', '{{ first }} for the first kilo, {{ extra }} for each extra kilo. The exact amount is confirmed at checkout from your postcode. Free delivery is not available here.', { first: CORE.fmt(CORE.EAST_FROM), extra: CORE.fmt(1000) })
      };
    }

    /* Any order containing frozen food uses the paid cold-chain tiers. */
    if (s.kind === 'mixed-progress' || s.kind === 'mixed-floor') {
      var atFloor = s.kind === 'mixed-floor';
      return {
        caption: (s.state === 'kl-sel' ? lbnT('ship.pop_cap_cold_kl', 'Cold-chain delivery \u00b7 KL / Selangor') : lbnT('ship.pop_cap_cold_outside_kl', 'Cold-chain delivery \u00b7 outside KL / Selangor')),
        fee: atFloor ? '<del>' + CORE.fmt(s.baseRate) + '</del>' + (s.rate === 0 ? lbnT('ship.free_caps', 'FREE') : CORE.fmt(s.rate)) : CORE.fmt(s.rate),
        showCart: true,
        mixed: true,
        threshold: s.threshold,
        pct: s.pct,
        won: atFloor,
        goal: atFloor
          ? (s.rate === 0 ? lbnT('ship.pop_goal_free_saved', 'You enjoy free delivery. You saved {{ amount }}', { amount: CORE.fmt(s.baseRate) })
            : lbnT('ship.you_saved_on_delivery_dot', 'You saved {{ amount }} on delivery.', { amount: CORE.fmt(Math.max(0, s.baseRate - s.rate)) }))
          : (CORE.seasonalNudge && CORE.seasonalNudge(s)) || (s.tierFree ? lbnT('ship.add_for_free_delivery_dot', 'Add {{ amount }} for free delivery.', { amount: '<strong>' + CORE.fmt(s.remaining) + '</strong>' }) : lbnT('ship.add_to_save_on_delivery_dot', 'Add {{ amount }} to save {{ saving }} on delivery.', { amount: '<strong>' + CORE.fmt(s.remaining) + '</strong>', saving: CORE.fmt(Math.max(0, s.tierSaving)) })),
        foot: '',
        choice: ''
      };
    }

    var threshold = frozen ? (s.autoFree ? CORE.TWM : (s.state === 'kl-sel' ? CORE.TKL : CORE.TWM)) : CORE.TDRY;
    var rate = frozen ? (s.autoFree ? CORE.RF_WM : (s.state === 'kl-sel' ? (s.total >= CORE.TKL_RED ? CORE.RF_KL_RED : CORE.RF_KL) : CORE.RF_WM)) : CORE.RD;
    var free = s.kind === 'free';
    var caption = frozen ? (s.autoFree ? lbnT('ship.pop_cap_cold_west', 'Cold-chain delivery · West Malaysia') : (s.state === 'kl-sel' ? lbnT('ship.pop_cap_cold_kl', 'Cold-chain delivery · KL / Selangor') : lbnT('ship.pop_cap_cold_short_outside_kl', 'Cold-chain · outside KL / Selangor'))) : lbnT('ship.pop_cap_regular_west', 'Regular delivery to West Malaysia');
    var fee = free ? lbnT('ship.free_caps', 'FREE') : CORE.fmt(rate);
    if (!free && frozen && s.state === 'kl-sel' && s.total >= CORE.TKL_RED) {
      fee = '<del>' + CORE.fmt(CORE.RF_KL) + '</del>' + CORE.fmt(CORE.RF_KL_RED);
    }

    var saved = frozen ? (s.autoFree ? CORE.RF_WM : (s.state === 'kl-sel' ? CORE.RF_KL : CORE.RF_WM)) : CORE.RD;
    var goal = free
      ? lbnT('ship.pop_goal_free_saved', 'You enjoy free delivery. You saved {{ amount }}', { amount: CORE.fmt(saved) })
      : lbnT('ship.pop_goal_add_more', 'Add {{ more }} for {{ free }}', { more: '<strong>' + lbnT('ship.pop_goal_amount_more', '{{ amount }} more', { amount: CORE.fmt(Math.max(0, threshold - s.total)) }) + '</strong>', free: '<span class="is-free-copy">' + lbnT('ship.pop_goal_free_delivery', 'FREE delivery') + '</span>' });
    var foot;
    if (!frozen) {
      foot = free
        ? ''
        : lbnT('ship.pop_foot_unlocks', 'Free delivery unlocks automatically when your cart reaches {{ amount }}.', { amount: fmtWhole(threshold) });
    } else if (s.state === 'kl-sel') {
      foot = free
        ? ''
        : (s.total >= CORE.TKL_RED
          ? lbnT('ship.pop_foot_kl_unlocked', "You've unlocked {{ off }} off delivery. The discounted {{ fee }} fee is already shown above.", { off: fmtWhole(Math.max(0, CORE.RF_KL - CORE.RF_KL_RED)), fee: fmtWhole(CORE.RF_KL_RED) })
          : lbnT('ship.pop_foot_kl_reach', 'Reach {{ threshold }} to unlock a discounted {{ fee }} delivery fee.', { threshold: fmtWhole(CORE.TKL_RED), fee: fmtWhole(CORE.RF_KL_RED) }));
    } else {
      foot = '';
    }
    return {
      caption: caption, fee: fee, free: free, showCart: true, threshold: threshold,
      pct: Math.min(100, Math.round(s.total / threshold * 100)), goal: goal, foot: foot
    };
  }

  /* Carl, 2026-09-18: a bare "ships in 2 parcels" notice left shoppers guessing.
     Show them the two boxes, what is in each, and WHY - the wording follows the
     CNY product-page FAQ so the store tells one story. */
  function boxList(items) {
    if (!items || !items.length) return '';
    return '<ul class="lbfsp__boxitems">' + items.map(function (i) {
      var name = esc(i.title || lbnT('ship.pop_item_fallback', 'Item'));
      return '<li>' + name + (i.qty > 1 ? ' <em>x' + i.qty + '</em>' : '') + '</li>';
    }).join('') + '</ul>';
  }

  /* Carl, 2026-09-18: lead with the outcome, one card per shipment, one sentence
     on how it is charged, one on tracking. No repeated totals, no wall of text. */
  function boxProgress(b) {
    var r = b.result || {};
    if (b.fee === 0) return '<span class="lbfsp__box-win">' + lbnT('ship.you_enjoy_free_delivery', 'You enjoy free delivery') + '</span>';
    if (r.kind === 'mixed-floor') return lbnT('ship.you_saved_on_delivery', 'You saved {{ amount }} on delivery', { amount: CORE.fmt(Math.max(0, r.baseRate - r.floorRate)) });
    if (r.kind === 'mixed-progress') return (CORE.seasonalNudge && CORE.seasonalNudge(r)) || lbnT('ship.add_to_save_on_delivery', 'Add {{ amount }} to save {{ saving }} on delivery', { amount: CORE.fmt(r.remaining), saving: CORE.fmt(Math.max(0, r.baseRate - r.floorRate)) });
    if (r.kind === 'progress' && r.remaining != null) return lbnT('ship.add_for_free_delivery', 'Add {{ amount }} for free delivery', { amount: CORE.fmt(r.remaining) });
    return '';
  }

  /* Long lists collapse to two lines; the toggle sits under the whole list, so the
     opened items continue in place and "Show less" is where the eye ends (Carl 10 Oct). */
  function boxList(items) {
    if (!items || !items.length) return '';
    var li = function (i, n) {
      return '<li' + (n >= 2 && items.length > 3 ? ' class="lbfsp__extra" hidden' : '') + '>' + esc(i.title || lbnT('ship.pop_item_fallback', 'Item')) + (i.qty > 1 ? ' <em>×' + i.qty + '</em>' : '') + '</li>';
    };
    var list = '<ul class="lbfsp__boxitems">' + items.map(li).join('') + '</ul>';
    if (items.length <= 3) return list;
    var label = lbnT('ship.pop_view_more_items', 'View {{ n }} more items', { n: items.length - 2 });
    return list + '<button type="button" class="lbfsp__more" data-lbfsp-more data-more="' + label + '" aria-expanded="false">' + label + '</button>';
  }

  function boxBlock(heading, b, quotable) {
    var prog = quotable ? boxProgress(b) : '';
    return '<div class="lbfsp__box">'
      + '<div class="lbfsp__box-head"><p class="lbfsp__box-t">' + heading + '</p>'
      + (quotable ? '<p class="lbfsp__box-fee">'
          + (b.saved > 0 ? '<del>' + CORE.fmt(b.baseFee) + '</del>' : '')
          + (b.fee === 0 ? '<span class="lbfsp__box-win">' + lbnT('ship.free_caps', 'FREE') + '</span>' : CORE.fmt(b.fee)) + '</p>' : '')
      + '</div>'
      + boxList(b.items)
      + (prog ? '<p class="lbfsp__box-prog">' + prog + '</p>' : '')
      + '</div>';
  }

  /* Simplified on Carl's call: the reason is stated ONCE, in the lede. The cards
     carry one number each plus the one line that tells the shopper what to do.
     Per-box subtotals and the repeated "why" block were noise. */
  function splitBoxesPanel(s) {
    var q = s.split;
    var quotable = !!(q && q.quotable);
    var seasonal = quotable ? q.seasonal : { items: s.boxes.seasonal.items, subtotal: s.boxes.seasonal.subtotal };
    var regular = quotable ? q.regular : { items: s.boxes.regular.items, subtotal: s.boxes.regular.subtotal };
    return '<div class="lbfsp__boxes">'
      + boxBlock(lbnT('ship.seasonal_box', 'Seasonal box'), seasonal, quotable)
      + boxBlock(lbnT('ship.regular_box', 'Regular box'), regular, quotable)
      + '</div>';
  }

  function rateKey(r) {
    if (!r) return null;
    if (r.seasonal) {
      if (r.seasonalQty >= CORE.SEA_FREE_QTY) return 'sea-qty';
      if (r.state === 'kl-sel') return r.total >= CORE.TSEA_KL ? 'sea-kl-free' : (r.total >= CORE.TKL_RED ? 'sea-kl-mid' : 'sea-kl-low');
      return r.total >= CORE.TSEA_WM ? 'sea-wm-free' : 'sea-wm-low';
    }
    if (r.frozen) {
      if (r.state === 'kl-sel') return r.total >= CORE.TMIX_KL ? 'cold-kl-high' : 'cold-kl-low';
      if (r.state === 'wm') return r.total >= CORE.TMIX_WM ? 'cold-wm-high' : 'cold-wm-low';
      return null;
    }
    if (r.state === 'east-msia') return 'rte-east-first';
    return r.total >= CORE.TDRY ? 'rte-west-high' : 'rte-west-low';
  }

  function rateCard(kind, marks) {
    var cold = kind === 'cold', sea = kind === 'seasonal';
    var rows = sea ? [
      ['sea-kl-low', lbnT('ship.kl_selangor', 'KL / Selangor'), lbnT('ship.pop_rate_below', 'Below {{ amount }}', { amount: 'RM150' }), 'RM20'],
      ['sea-kl-mid', lbnT('ship.kl_selangor', 'KL / Selangor'), 'RM150+', 'RM10'],
      ['sea-kl-free', lbnT('ship.kl_selangor', 'KL / Selangor'), 'RM200+', 'FREE'],
      ['sea-wm-low', lbnT('ship.pop_rate_other_wm', 'Other West Malaysia'), lbnT('ship.pop_rate_below', 'Below {{ amount }}', { amount: 'RM300' }), 'RM30'],
      ['sea-wm-free', lbnT('ship.pop_rate_other_wm', 'Other West Malaysia'), 'RM300+', 'FREE'],
      ['sea-qty', lbnT('ship.west_malaysia', 'West Malaysia'), lbnT('ship.pop_rate_two_seasonal', '2+ seasonal dishes'), 'FREE']
    ] : cold ? [
      ['cold-kl-low', lbnT('ship.kl_selangor', 'KL / Selangor'), lbnT('ship.pop_rate_below', 'Below {{ amount }}', { amount: 'RM150' }), 'RM20'],
      ['cold-kl-high', lbnT('ship.kl_selangor', 'KL / Selangor'), 'RM150+', 'RM10'],
      ['cold-wm-low', lbnT('ship.pop_rate_other_wm', 'Other West Malaysia'), lbnT('ship.pop_rate_below', 'Below {{ amount }}', { amount: 'RM300' }), 'RM30'],
      ['cold-wm-high', lbnT('ship.pop_rate_other_wm', 'Other West Malaysia'), 'RM300+', 'RM15']
    ] : [
      ['rte-west-low', lbnT('ship.west_malaysia', 'West Malaysia'), lbnT('ship.pop_rate_below', 'Below {{ amount }}', { amount: 'RM150' }), 'RM8'],
      ['rte-west-high', lbnT('ship.west_malaysia', 'West Malaysia'), 'RM150+', 'FREE'],
      ['rte-east-first', lbnT('ship.sabah_sarawak', 'Sabah / Sarawak'), lbnT('ship.pop_rate_first_kg', 'First kg'), 'RM16'],
      ['rte-east-extra', lbnT('ship.sabah_sarawak', 'Sabah / Sarawak'), lbnT('ship.pop_rate_extra_kg', 'Each extra kg'), '+RM10']
    ];
    var html = '<div class="lbfsp__ratecard"><div class="lbfsp__ratehead"><b>'
      + (sea ? lbnT('ship.seasonal_box', 'Seasonal box').toUpperCase() : cold ? lbnT('ship.pop_rate_head_cold', 'COLD-CHAIN DELIVERY') : lbnT('ship.pop_rate_head_rte', 'READY-TO-EAT ONLY')) + '</b><span>'
      + (sea ? lbnT('ship.pop_rate_sub_seasonal', 'Ships in its own box') : cold ? lbnT('ship.pop_rate_sub_cold', 'Minimum 3 frozen dishes') : lbnT('ship.pop_rate_sub_rte', 'Regular courier')) + '</span></div>';
    rows.forEach(function (row) {
      var labels = marks[row[0]] || [];
      html += '<div class="lbfsp__raterow' + (labels.length ? ' is-current' : '') + '"><span>' + row[1]
        + (labels.length ? '<small class="lbfsp__ratemark">' + labels.map(esc).join(' · ') + '</small>' : '')
        + '</span><span>' + row[2] + '</span><span class="lbfsp__ratefee' + (row[3] === 'FREE' ? ' is-free' : '') + '">' + (row[3] === 'FREE' ? lbnT('ship.free_caps', 'FREE') : row[3]) + '</span></div>';
    });
    return html + '</div>';
  }

  function shippingTables(s, frozen) {
    if (s.kind === 'blocked' || s.kind === 'pickstate' || s.kind === 'moq' || s.kind === 'empty') return '';
    var coldMarks = {}, rteMarks = {}, seaMarks = {};
    var addMark = function (r, label) {
      var key = rateKey(r);
      if (!key) return;
      var target = r.seasonal ? seaMarks : r.frozen ? coldMarks : rteMarks;
      target[key] = target[key] || [];
      target[key].push(label);
    };
    if (s.splitWarn && s.split && s.split.quotable) {
      addMark(s.split.seasonal.result, lbnT('ship.seasonal_box', 'Seasonal box'));
      addMark(s.split.regular.result, lbnT('ship.regular_box', 'Regular box'));
    } else {
      addMark(s, lbnT('ship.pop_mark_your_order', 'Your order'));
    }
    var hasCold = Object.keys(coldMarks).length > 0;
    var hasRte = Object.keys(rteMarks).length > 0;
    var primaryCold = hasCold || (!hasRte && frozen);
    var primary = primaryCold ? rateCard('cold', coldMarks) : rateCard('rte', rteMarks);
    var secondary = primaryCold ? rateCard('rte', rteMarks) : rateCard('cold', coldMarks);
    /* a seasonal box: its own rates first, then the card for the rest of the order */
    if (Object.keys(seaMarks).length) { secondary = primary; primary = rateCard('seasonal', seaMarks); }
    return '<div class="lbfsp__rates"><details class="lbfsp__all-rates"><summary>' + lbnT('ship.pop_see_all_rates', 'See all delivery rates') + '</summary>'
      + '<div class="lbfsp__all-rates-body"><p class="lbfsp__rates-title">' + lbnT('ship.pop_rates_title', 'Delivery rates for this order') + '</p>'
      + primary + '<div class="lbfsp__rate-gap" aria-hidden="true">&#8203;</div>' + secondary + '</div></details></div>';
  }

  function renderStep2() {
    var s = current();
    var frozen = frozenCart();
    var blocked = s.kind === 'blocked';
    /* A split cart must NOT be told its dishes travel together - they do not. */
    var title = blocked
      ? lbnT('ship.pop_title_blocked', "Frozen delivery isn't available to Sabah or Sarawak")
      : (s.splitWarn ? lbnT('ship.pop_title_split', 'This order requires 2 separate shipments')
        : (frozen ? lbnT('ship.pop_title_frozen', 'Your order will ship by cold chain.') : lbnT('ship.pop_title_rte', "How we'll ship your order")));
    var h = singleTargetCard(s, frozen);
    var vn = blocked ? null : s.voucherNote;
    if (vn) {
      h.fee = '<del>' + CORE.fmt(s.feeBase) + '</del>' + (s.feeAfter ? CORE.fmt(s.feeAfter) : lbnT('ship.free_caps', 'FREE'));
      if (vn.kind === 'free' || s.kind === 'free' || s.kind === 'mixed-floor') { h.goal = vn.text + '.'; h.foot = ''; }
      if (vn.kind === 'free') { h.free = true; h.threshold = null; }
    }
    var animClass = animatePanel ? (direction === 'back' ? 'is-back' : 'is-forward') : '';
    var html = '<div class="lbfsp__panel ' + animClass + '"><h2 id="lbfsp-title">' + title + '</h2>' +
      /* Carl 2026-09-18: the charging rule reads with the reason, as a second
         paragraph, BEFORE the shopper meets the number. */
      '<p class="lbfsp__lede">' + sentence(s, frozen) + '</p>'
      + ((s.splitWarn && !blocked && s.boxes) ? '<p class="lbfsp__lede is-second">' + lbnT('ship.pop_split_charged', 'Each shipment is charged separately. You will receive 2 tracking numbers, one per box.') + '</p><p class="lbfsp__lede is-second">' + lbnT('ship.pop_split_qualify', 'Each box can still qualify for discounted or free delivery, based on its own subtotal.') + '</p>' : '')
      + '<div class="lbfsp__hero' + (h.free || h.won ? ' is-free' : '') + (h.flat ? ' is-flat' : '') + (h.mixed ? ' is-mixed' : '') + '">' +
      (h.caption ? '<p class="lbfsp__caption">' + h.caption + '</p>' : '') + '<div class="lbfsp__fee-row"><p class="lbfsp__fee-label">' + (h.feeLabel || lbnT('ship.pop_delivery_fee', 'Delivery fee')) + '</p><p class="lbfsp__figure' + (h.free || h.won ? ' is-free' : '') + '">' + h.fee + (s.splitWarn && !blocked && !h.splitTotal ? '<span class="lbfsp__split-more">+</span>' : '') + '</p></div>';
    if (h.showCart) {
      html += '<div class="lbfsp__cartrow"><span>' + lbnT('ship.pop_your_cart', 'Your cart') + '</span><span class="lbfsp__cartrow-value">' + (cart && cart.voucher && cart.voucher.order ? '<del>' + CORE.fmt(s.total + cart.voucher.order.cents) + '</del>' : '') + CORE.fmt(s.total) + (h.threshold ? ' <em>' + lbnT('ship.pop_cart_of', 'of {{ amount }}', { amount: fmtWhole(h.threshold) }) + '</em>' : '') + '</span></div>';
    }
    if (h.threshold) html += '<div class="lbfsp__track"><i style="width:' + h.pct + '%"></i></div>';
    if (h.goal) html += '<p class="lbfsp__goal' + (h.free || h.won ? ' is-done' : '') + (!h.threshold ? ' is-flat' : '') + '">' + h.goal + '</p>' + (h.foot ? '<p class="lbfsp__foot">' + h.foot + '</p>' : '');
    /* Explanatory only - deliberately NOT a one-click "remove my frozen items"
       button (brief section 5). The shopper edits the cart themselves. */
    if (s.splitWarn && !blocked && s.boxes) html += splitBoxesPanel(s);
    if (h.choice) html += '<p class="lbfsp__choice">' + h.choice + '</p>';
    html += '</div>' + shippingTables(s, frozen);
    if (!blocked) {
      html += '<div class="lbfsp__buttons"><button type="button" class="lbfsp__btn is-ghost" data-lbfsp-change>' + lbnT('ship.change_location', 'Change location') + '</button><button type="button" class="lbfsp__btn" data-lbfsp-close>' + lbnT('ship.pop_got_it', 'Got it') + '</button></div>';
    } else {
      html += '<div class="lbfsp__buttons"><button type="button" class="lbfsp__btn is-ghost" data-lbfsp-remove>' + lbnT('ship.pop_remove_frozen', 'Remove frozen dishes') + '</button><button type="button" class="lbfsp__btn" data-lbfsp-change>' + lbnT('ship.change_location', 'Change location') + '</button></div>';
    }
    return html + '</div>';
  }

  function render() {
    if (!rootEl) return;
    var content = rootEl.querySelector('.lbfsp__content');
    var animateHeight = animatePanel && rootEl.classList.contains('is-open') && !reducedMotion();
    var oldHeight = animateHeight ? sheetEl.getBoundingClientRect().height : 0;
    clearHeightMotion();
    // Measure the natural destination, not scrollHeight constrained by the old height.
    // Otherwise shorter screens retain the old height until cleanup, then snap shut.
    sheetEl.style.transition = 'none';
    content.innerHTML = step === 1 ? renderStep1() : renderStep2();
    if (animateHeight) {
      var targetHeight = sheetEl.getBoundingClientRect().height;
      sheetEl.style.overflow = 'hidden';
      sheetEl.style.height = oldHeight + 'px';
      sheetEl.scrollTop = 0;
      void sheetEl.offsetHeight;
      sheetEl.style.transition = '';
      sheetEl.style.height = targetHeight + 'px';
      heightTimer = window.setTimeout(clearHeightMotion, 300);
    } else sheetEl.style.transition = '';
    if (animatePanel) sheetEl.focus({ preventScroll: true });
    push('lbf_ship_step_view', { step: step, surface: surface(), lane: current().lane || null });
    if (step === 2) push('lbf_ship_sheet_view', { source: trigger + (reason && reason !== 'manual' ? ':' + reason : ''), surface: surface(), lane: current().lane || null });
  }

  function onClick(e) {
    var target = e.target;
    var more = target.closest && target.closest('[data-lbfsp-more]');
    if (more) {
      var open = more.getAttribute('aria-expanded') !== 'true';
      more.setAttribute('aria-expanded', open ? 'true' : 'false');
      more.textContent = open ? lbnT('ship.pop_show_less', 'Show less') : more.getAttribute('data-more');
      [].forEach.call(more.previousElementSibling.querySelectorAll('.lbfsp__extra'), function (li) { li.hidden = !open; });
      return;
    }
    var area = target.closest && target.closest('[data-lbfsp-area]');
    if (area && !area.disabled) {
      var wasBlocked = current().kind === 'blocked';
      var frozen = frozenCart();
      var from = frozen ? CORE.getFrozenRegion() : CORE.getRegularRegion();
      var to = area.getAttribute('data-lbfsp-area');
      if (frozen) {
        if (wasBlocked && CORE.getRegularRegion() === 'east-msia') CORE.setRegularRegion('west-msia');
        CORE.setFrozenRegion(to);
      } else {
        CORE.setRegularRegion(to);
      }
      changedArea = changedArea || from !== to;
      push('lbf_area_change', { from: from, to: to, surface: surface(), lane: current().lane || null });
      if (wasBlocked) push('lbf_blocked_resolve', { via: 'changed_area' });
      announceState(to);
      animatePanel = true; direction = 'forward'; step = 2; render(); animatePanel = false; return;
    }
    if (target.closest && target.closest('[data-lbfsp-change]')) { reason = 'manual'; animatePanel = true; direction = 'back'; step = 1; render(); animatePanel = false; return; }
    if (target.closest && target.closest('[data-lbfsp-remove]')) {
      try { document.dispatchEvent(new CustomEvent('lbf:remove-frozen-request')); } catch (err) {}
      close('removed-frozen'); return;
    }
    if (target.closest && target.closest('[data-lbfsp-close]')) close('button');
  }

  function open(options) {
    options = options || {};
    ensure();
    cart = options.cart || cart;
    trigger = options.trigger || 'button';
    reason = options.reason || 'manual';
    opener = options.opener || document.activeElement;
    changedArea = false;
    openedAt = Date.now();
    direction = 'forward';
    var s = current();
    var active = getState();
    step = s.kind === 'blocked' ? 2 : (active ? (options.step || 2) : 1);
    render();
    if (!rootEl.classList.contains('is-open')) previousOverflow = document.body.style.overflow;
    rootEl.classList.add('is-open');
    rootEl.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    push('lbf_ship_popup_open', { surface: surface(), step: step, trigger: trigger, lane: current().lane || (frozenCart() ? 'cold-chain' : 'regular'), area: active });
    window.setTimeout(function () { if (sheetEl) sheetEl.focus(); }, 0);
  }

  function close(reason) {
    if (!rootEl || !rootEl.classList.contains('is-open')) return;
    if (current().kind === 'blocked' && reason !== 'removed-frozen') push('lbf_blocked_resolve', { via: 'abandoned' });
    push('lbf_ship_popup_dismiss', { surface: surface(), last_step: step, dwell_ms: Date.now() - openedAt, changed_area: changedArea, lane: current().lane || null });
    rootEl.classList.remove('is-open');
    clearHeightMotion();
    rootEl.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = previousOverflow;
    if (opener && opener.focus) opener.focus();
  }

  function update(nextCart) { cart = nextCart || cart; if (rootEl && rootEl.classList.contains('is-open')) render(); }

  window.LBF_SHIPPING_POPUP = { open: open, close: close, update: update };
})();
